import React, { useEffect, useState } from 'react';
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/Agreement/agreement.scss'
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import pdfFIleIcon from '../../../../../../asset/svg/pdfFile.svg'
import { Await, useNavigate } from 'react-router';
import { ASSETS_REGISTER_PATH, DOWNLOAD_QR_PAGE_PATH } from '../../../../../../utils/Constants';
import { Backdrop, Chip, CircularProgress, Modal, Stack, Typography } from '@mui/material';
import DocImage from '../../../../../../asset/svg/docImage.svg'
import { Box } from '@mui/system';
import TickSuccess from '../../../../../../asset/svg/tickImageSuccess.svg'
import DownloadAgreement from './DownloadAgreement/downloadAgreement';
import { useDispatch, useSelector } from 'react-redux';
import { GET_AGREEMENT_LATEST_DATA, GET_AGREEMENT_UPLOADFILE_OBJECT_DATA, HIDE_MODAL_SELECT_STORE, POST_AGREEMENT_UPLOAD_DATA, SHOW_MODAL_ASSETGROUP } from '../../../../../../sagas/type';
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';
import { generateRandomId } from '../../../../../../components/common/GenerateRandomId/GenerateRandomId';
import { getLocalStoreString } from '../../../../../../utils/Helper';
import DescriptionIcon from '@mui/icons-material/Description';
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import * as PdfJs from "pdfjs-dist";
import jsPDF from 'jspdf';
import imageCompression from 'browser-image-compression';
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

function Agreement() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar()
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const getStoreCode = getLocalStoreString("storeCode");
    const { AgreementDraftData, AgreementUploaded, SelectedStoreDatas, CheckIsiOSDevice } = useSelector(mapStateToProps);
    const [objId, setObjId] = useState()
    const [uploadPhotos, setUploadPhotos] = useState([])
    const [isAgreementUploaded, setIsAgreementUploaded] = useState(false);
    const [isDownloadAgreement, setIsDownloadAgreement] = useState(false)
    const [uploadPdf, setUploadPdf] = useState([])
    const [pdfData, setPdfData] = useState()
    const [viewPdf, setViewPdf] = useState()
    const [viewPdfType, setViewPdfType] = useState();
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false)
    const [statusRes, setStatusRes] = useState()
    const [updatedDraftfile, setUpdatedDraftfile] = useState([])
    const [fileTypeView, setFileTypeView] = useState()
    const [fileUploadApi, setFileUploadApi] = useState([])
    const [disableUploadButton, setDisableUploadbutton] = useState(true)
    const [disableSubmitButton, setDisableSubmitbutton] = useState(false)
    const [loader, setLoader] = useState(false)
    const [ableEdit, setAbleEdit] = useState(false)
    const [cameraModalOpen, setCameraModalOpen] = useState(false);
    const [facingMode, setFacingMode] = useState('environment');
    const handleBack = () => {
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
    }

    const handleClose = (event, reason) => {
        if (reason !== "backdropClick") {
            setIsAgreementUploaded(false)
        }
    };

    const switchCamera = () => {
        setFacingMode(prevMode => (prevMode === 'environment' ? 'user' : 'environment'));
    };

    const handleEditUploadPhoto = () => {
        setAbleEdit(false)
        setDisableUploadbutton(true);
        setDisableSubmitbutton(false);
    }

    const handleClickButton = () => {
        dispatch({
            type: POST_AGREEMENT_UPLOAD_DATA,
            payload: {
                employeeCode: EmployeeCode,
                storeCode: getStoreCode,
                objectId: objId?.id
            },
            setIsAgreementUploaded: setIsAgreementUploaded,
            setStatusRes: setStatusRes,
            enqueueSnackbar: enqueueSnackbar,
        })
        setDisableSubmitBtn(false)
    }
    const handleDownloadQR = () => {
        setIsAgreementUploaded(false)
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
    }

    const getAgreementData = () => {
        const storeCode = getLocalStoreString("storeCode");
        dispatch({
            type: GET_AGREEMENT_LATEST_DATA,
            payload: storeCode,
        })
    }

    useEffect(() => {
        setUpdatedDraftfile(AgreementDraftData)
        getAgreementData()
    }, [])

    const handleViewPdfDocument = (fileUrl, fileType, fileViewType) => {
        setViewPdfType(fileType)
        setViewPdf(fileUrl)
        setFileTypeView(fileViewType)
        setIsDownloadAgreement(true)
    }

    const convertPdfToImages = async (file) => {
        return new Promise(async (resolve, reject) => {
            const objectURL = window?.URL?.createObjectURL(file);
            PdfJs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PdfJs.version}/pdf.worker.min.js`;
            PdfJs.getDocument({ url: objectURL }).promise.then(async (pdf) => {
                const images = [];
                const numPages = pdf.numPages;
                const imageQuality = 0.7;
                for (let index = 1; index <= numPages; index++) {
                    const page = await pdf.getPage(index);
                    const viewport = page.getViewport({ scale: 1.5 });
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    const renderContext = {
                        canvasContext: context,
                        viewport: viewport,
                    };
                    await page.render(renderContext).promise;
                    const imageDataURL = canvas.toDataURL("image/jpeg", imageQuality);
                    images.push(imageDataURL);
                }
                resolve(images);
            }).catch((error) => {
                reject(error);
            });
        });
    };

    const mergeImagesToPdf = async (images) => {
        return new Promise((resolve) => {
            const doc = new jsPDF("p", "mm", "a4");
            const imageWidth = 210;
            const imageHeight = 297;
            images.forEach((image, index) => {
                if (index !== 0) {
                    doc.addPage();
                }
                doc.addImage(
                    image,
                    "JPEG",
                    0,
                    0,
                    imageWidth,
                    imageHeight,
                    undefined,
                    "FAST"
                );
            });
            const mergedPdfBlob = doc.output("blob");
            resolve(mergedPdfBlob);
        });
    };

    const compressPdf = async (file) => {
        try {
            const images = await convertPdfToImages(file);
            const mergedPdfBlob = await mergeImagesToPdf(images);
            const fileName = file.name.replace(".pdf", "_compressed.pdf");
            const compressedPdfBlob = new File([mergedPdfBlob], fileName, {
                type: "application/pdf",
            });
            return compressedPdfBlob;
        } catch (error) {
            throw error;
        }
    };


    const handleUploadFile = async (e) => {
        setLoader(true)
        const newFilesArray = [];
        if (CheckIsiOSDevice == 'iOS') {
            let allowUpload = true;
            for (let i = 0; i < e.target.files.length; i++) {
                const file = e.target.files[i];
                const ext = file.name.split('.').pop().toLowerCase();
                if (ext === 'pdf') {
                    setLoader(true)
                    if (uploadPdf.length < 1) {
                        if (file.size > 5 * 1024 * 1024) {
                            await compressPdf(file).then((compressedBlob) => {
                                if (compressedBlob) {
                                    if (compressedBlob?.size > 5 * 1024 * 1024) {
                                        setLoader(false)
                                        enqueueSnackbar('File size cannot be more than 5MB', { variant: 'error' });
                                        allowUpload = false;
                                    }
                                    else {
                                        newFilesArray.push({ file: compressedBlob, url: URL.createObjectURL(compressedBlob) });
                                        allowUpload = true;
                                        setLoader(false)
                                    }
                                }
                            }).catch((error) => {
                                setLoader(false)
                                console.error(error);
                            });
                        } else {
                            newFilesArray.push({ file: file, url: URL.createObjectURL(file) });
                            setLoader(false)
                        }
                    } else {
                        setLoader(false)
                        enqueueSnackbar('You cannot add PDF and Image together.', { variant: 'error' });
                        allowUpload = false;
                    }
                }
            }
            setFileUploadApi(newFilesArray);
            if (allowUpload) {
                const newFiles = [...uploadPdf];
                for (let i = 0; i < e?.target?.files?.length; i++) {
                    const randomId = generateRandomId(8)
                    const fileObject = {
                        id: randomId,
                        file: e.target.files[i],
                        url: URL.createObjectURL(e.target.files[i]),
                    };
                    newFiles.push(fileObject);
                }
                setUploadPdf(newFiles);
                setLoader(false)
            }
        } else {
            let allowUpload = true;
            if (allowUpload) {
                const blob = dataURItoBlob(e)
                const fileData = new File([blob], `captured-image-${Date.now()}.jpg`, { type: 'image/jpeg' });
                const newFiles = [...uploadPdf];
                const randomId = generateRandomId(8)
                const fileObject = {
                    id: randomId,
                    file: fileData,
                    url: URL.createObjectURL(fileData),
                    size: fileData.size,
                };
                newFiles.push(fileObject);
                setUploadPdf(newFiles);
                setCameraModalOpen(false);
                setLoader(false)
            }
        }
    };

    const convertToPdf = async (imageDataUrls) => {
        const pdf = new jsPDF();

        for (let index = 0; index < imageDataUrls.length; index++) {
            const imageUrl = imageDataUrls[index];

            await new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.src = imageUrl;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, img.width, img.height);

                    try {
                        const dataUrl = canvas.toDataURL('image/jpeg');
                        pdf.addImage(dataUrl, 'JPEG', 0, 0, 210, 297);

                        if (index < imageDataUrls.length - 1) {
                            pdf.addPage();
                        }

                        resolve();
                    } catch (error) {
                        console.error('Error converting canvas to data URL:', error);
                        resolve();
                    }
                };

                img.onerror = (error) => {
                    console.error('Error loading image:', error);
                    resolve();
                };
            });
        }

        const pdfBlob = pdf.output('blob');
        return pdfBlob;
    };



    const imageSize = (images) => {
        let totalSize = 0;
        for (let i = 0; i < images?.length; i++) {
            const fileObj = images[i];
            totalSize += fileObj?.size;
        }
        return totalSize;
    }

    const resizeImage = async (file, maxWidthOrHeight) => {
        const img = new Image();

        return new Promise((resolve) => {
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const aspectRatio = img.width / img.height;
                let width, height;

                if (img.width > img.height) {
                    width = Math.min(maxWidthOrHeight, img.width);
                    height = width / aspectRatio;
                } else {
                    height = Math.min(maxWidthOrHeight, img.height);
                    width = height * aspectRatio;
                }

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    resolve(blob);
                }, file?.type);
            };

            img.src = URL.createObjectURL(file);
        });
    };

    const ImageCompression = async (images) => {
        let options = {
            maxWidthOrHeight: 2000,
        };
        let totalSize = 0;

        // Associate each image with its index in the images array
        const imagesWithIndex = images.map((image, index) => ({ index, file: image?.file }));

        for (const image of imagesWithIndex) {
            totalSize += image?.file?.size;
        }

        let tempImages = [];

        do {
            options.maxWidthOrHeight = options.maxWidthOrHeight * 0.95;
            tempImages = [];

            for (const image of imagesWithIndex) {
                const fileObject = image?.file;
                const compressedFile = await resizeImage(fileObject, options?.maxWidthOrHeight);
                tempImages.push(compressedFile);
            }

            totalSize = imageSize(tempImages);
        } while (totalSize > 5 * 1024 * 1024);

        // Sort tempImages based on the original indices
        tempImages.sort((a, b) => a.index - b.index);

        return tempImages;
    };



    const handleUploadFilesConvertToPdf = async () => {
        setAbleEdit(true);
        setLoader(true);
        const randomId = generateRandomId(8);
        const blobUrl = [];

        if (uploadPdf?.length > 0) {
            const firstUpload = uploadPdf[0];
            if (firstUpload?.file?.type?.startsWith('image/')) {
                try {
                    const compressedImages = await ImageCompression(uploadPdf);

                    compressedImages.forEach((image) => {
                        const compressedDataUrl = URL.createObjectURL(image);
                        blobUrl?.push(compressedDataUrl);
                    })
                } catch (error) {
                    console.error('Error compressing image:', error);
                }

            }
        }
        const pdfBlob = await convertToPdf(blobUrl);
        const pdfFile = new File([pdfBlob], 'Agreement.pdf', { type: 'application/pdf' });

        if (pdfBlob.size > 5 * 1024 * 1024) {
            setLoader(false);
            enqueueSnackbar('Compressed image exceeds 5MB. Please choose a smaller image.', { variant: 'error' });
        } else {
            setLoader(true)
            const uploadFile = {
                file: pdfFile,
                randomId,
            };

            dispatch({
                type: GET_AGREEMENT_UPLOADFILE_OBJECT_DATA,
                payload: {
                    employeeCode: EmployeeCode,
                    uploadFile: uploadFile?.file,
                },
                setUploadPhotos: setUploadPhotos,
                setObjId: setObjId,
                setLoader: setLoader,
                enqueueSnackbar: enqueueSnackbar,
                setDisableUploadbutton: setDisableUploadbutton,
                setDisableSubmitbutton: setDisableSubmitbutton,
            });
        }

        if (uploadPdf.some((fileObj) => fileObj.file.type === 'application/pdf')) {
            if (fileUploadApi.length > 0) {
                setLoader(true)
                fileUploadApi.map((uploadFile) => {
                    return dispatch({
                        type: GET_AGREEMENT_UPLOADFILE_OBJECT_DATA,
                        payload: {
                            employeeCode: EmployeeCode,
                            uploadFile: uploadFile?.file,
                        },
                        setUploadPhotos: setUploadPhotos,
                        setObjId: setObjId,
                        setLoader: setLoader,
                        enqueueSnackbar: enqueueSnackbar,
                        setDisableUploadbutton: setDisableUploadbutton,
                        setDisableSubmitbutton: setDisableSubmitbutton,
                    });
                });
            }
        }
    };




    const handleFileDelete = (id) => {
        setDisableUploadbutton(true);
        setDisableSubmitbutton(false)
        const newFiles = uploadPdf?.filter(file => file?.id !== id);
        setUploadPdf(newFiles);
    }
    const handleFileDelete2 = (id) => {
        const deleteData = updatedDraftfile?.signedFiles?.filter((item) => item?.objectId !== id)
        setUpdatedDraftfile(deleteData)
    }

    const renderFileSignedFile = (fileObj, index) => {
        return (
            <div key={index} style={{ width: "130px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={pdfFIleIcon} height="40px" width="30px" />
            </div>
        )
    }

    const renderFileUploadFile = (fileObj, index) => {
        const ext = fileObj?.file?.name?.split('.').pop().toLowerCase();
        if (ext === 'pdf') {
            return (
                <div key={index} style={{ borderRadius: "16px", width: "130px", height: "175px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={pdfFIleIcon} height="40px" width="30px" />
                </div>
            )
        } else {
            return (
                <div key={index} style={{ width: "130px", height: "175px", borderRadius: "16px" }}>
                    <img src={fileObj?.url} alt='' style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "16px" }} />
                </div>
            );
        }
    }

    useEffect(() => {
        fetch(AgreementDraftData?.draftFile)
            .then(response => response.blob())
            .then(async (data) => setPdfData(data))
    }, [AgreementDraftData?.draftFile], uploadPdf);

    useEffect(() => {
        if (statusRes == 200) {
            if (uploadPdf.length > 0) {
                if (objId?.id == AgreementUploaded?.signedFiles[0]?.objectId) {
                    setDisableSubmitBtn(true)
                } else if (objId?.id !== AgreementUploaded?.signedFiles[0]?.objectId) {
                    setDisableSubmitBtn(false)
                }
            }
        } else if (uploadPdf.length <= 0) {
            setDisableSubmitBtn(true)
        }
        if (uploadPdf.length > 0) {
            if (statusRes == 200) {
                if (objId?.id == AgreementUploaded?.signedFiles[0]?.objectId) {
                    setDisableSubmitBtn(true)
                }
            } else {
                setDisableSubmitBtn(false)
            }
        } else if (uploadPdf.length <= 0) {
            setDisableSubmitBtn(true)
        }
    }, [objId, uploadPdf, statusRes, disableSubmitBtn])

    const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: 'image/jpeg' });
    };

    const aspectRatio = 4 / 3; // 4:3 aspect ratio

    const Iwidth = 2560;
    const Iheight = Math.round(Iwidth / aspectRatio);
    const ratio = { width: Iwidth, height: Iheight }

    console.log("uploadPdf", uploadPdf);
    return (
        <>
            <div className='Agreement-Container'>
                <div className='Agreement-Container_header'>
                    <div>
                        <img className='Agreement-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='Agreement-Container_header_content'>Agreement</span>
                    </div>
                    {SelectedStoreDatas && SelectedStoreDatas.length && <div>
                        <Stack direction="row" spacing={1} sx={{ width: "fit-content", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%" }} className='Agreement-Container_header_Stock-chip'>
                            <Chip label={SelectedStoreDatas && SelectedStoreDatas.length && SelectedStoreDatas[0]?.name} className='Agreement-Container_header_Stock-chip_Store-chip' sx={{ color: "#12B9DD", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>
                    </div>}
                </div>
                <div className='Agreement-Container_card-Parent-Container2'>
                    <div className="Agreement-Container_card-Parent-Container2_Card-Container">
                        <img src={DocImage} />
                        <div className="Agreement-Container_card-Parent-Container2_Card-Container_Card-text-container">
                            <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: "16px" }}>Draft Agreement</Typography>
                            <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontWeight: 400, fontSize: "12px" }}>{moment(AgreementDraftData.draftUploadedAt).format("DD MMM YYYY - HH:mm A")}</Typography>
                            <button id="share" disabled={!AgreementDraftData?.draftFile?.length} className='Agreement-Container_card-Parent-Container2_Card-Container_Card-text-container_active-button' /*onClick={handleDownload}*/ onClick={() => handleViewPdfDocument(AgreementDraftData?.draftFile, "Draft")}>View</button>
                        </div>
                    </div>
                </div>
                <div className='Agreement-Container_Signed-Agreement'>
                    <div className='Agreement-Container_Signed-Agreement_Flex'>
                        <Typography sx={{ color: "#fff", fontSize: "16px", fontWeight: 600 }}>Signed Agreement</Typography>
                        {AgreementDraftData?.workflowStatus == 'REJECTED' && <Stack direction="row" spacing={1} className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2' sx={{ border: "0.5px solid #FF7272", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", background: "rgba(255, 114, 114, 0.20)" }}>
                            <Chip label='Rejected' className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2_Store-chip2' sx={{ color: "#FF7272", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>}
                        {AgreementDraftData?.workflowStatus == 'IN_REVIEW' && <Stack direction="row" spacing={1} className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2' sx={{ border: "0.5px solid #EAA439", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", background: "rgba(234, 164, 57, 0.20)" }}>
                            <Chip label='In Review' className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2_Store-chip2' sx={{ color: "#EAA439", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>}
                        {AgreementDraftData?.workflowStatus == 'APPROVED' && <Stack direction="row" spacing={1} className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2' sx={{ border: "0.5px solid #6FDF97", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", background: "rgba(111, 223, 151, 0.20)" }}>
                            <Chip label='Approved' className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2_Store-chip2' sx={{ color: "#6FDF97", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>}
                        {AgreementDraftData?.workflowStatus == 'NONE' && <Stack direction="row" spacing={1} className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2' sx={{ border: "0.5px solid #FF7272", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", background: "rgba(255, 114, 114, 0.20)" }}>
                            <Chip label='Pending' className='Agreement-Container_Signed-Agreement_Flex_Stock-chip2_Store-chip2' sx={{ color: "#FF7272", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>}
                    </div>
                    <div className='Agreement-Container_Signed-Agreement_Flex2'>
                        {AgreementDraftData?.signedFiles?.length > 0 && <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontSize: "12px", fontWeight: 400, whiteSpace: "nowrap" }}>Last Updated on {moment(AgreementDraftData?.signedUploadedAt).format("DD MMM YYYY - HH:mm A")}</Typography>}
                        {ableEdit ?
                            <div className='Agreement-Container_Signed-Agreement_Flex2_Add-photo'>
                                <Typography sx={{ color: '#4B2EF1', fontSize: "12px" }} onClick={handleEditUploadPhoto}>Reupload</Typography>
                            </div> : <>
                                {uploadPdf?.length >= 2 && uploadPdf?.length < 5 && <div className='Agreement-Container_Signed-Agreement_Flex2_Add-photo'>
                                    {CheckIsiOSDevice == 'iOS' ? <label>
                                        <input id="formId" type="file" onChange={handleUploadFile} multiple accept="application/pdf, image/*" capture="environment" />
                                        <Typography sx={{ color: '#4B2EF1', fontSize: "12px" }}>Add Photo</Typography>
                                    </label> :
                                        <label onClick={() => setCameraModalOpen(true)}>
                                            <Typography sx={{ color: '#4B2EF1', fontSize: "12px" }}>Add Photo</Typography>
                                        </label>
                                    }
                                </div>}
                            </>
                        }
                    </div>
                </div>
                <div className='Agreement-Container_Signed-Agreement-Content'>
                    {uploadPdf.length > 0 && uploadPdf.map((fileObj, index) => {
                        return (
                            <div key={index} className='Agreement-Container_Signed-Agreement-Content_Signed-copy-or'>
                                {!ableEdit && <ClearIcon sx={{ width: "16px", height: "16px", color: "#FFF", opacity: "0.8", position: "absolute", top: 10, right: 10 }} onClick={() => handleFileDelete(fileObj?.id)} />}
                                <div onClick={() => handleViewPdfDocument(fileObj?.url, "", fileObj?.file?.type)} className='Agreement-Container_Signed-Agreement-Content_Signed-copy-or_ViwerCard'>
                                    {renderFileUploadFile(fileObj, fileObj?.id)}
                                </div>
                            </div>
                        )
                    })}
                    {!ableEdit && !uploadPdf.some(fileObj => fileObj.file.type === 'application/pdf') && uploadPdf.length > 0 && uploadPdf.length < 2 && (
                        <div className='Agreement-Container_Signed-Agreement-Content_Signed-copy-or'>
                            {CheckIsiOSDevice == 'iOS' ?
                                <label>
                                    <div className='Agreement-Container_Signed-Agreement-Content_Signed-copy-or_AddFile-Container'>
                                        <input id="formId" type="file" onChange={handleUploadFile} multiple accept="application/pdf, image/*" capture="environment" />
                                        <AddIcon sx={{ width: "20px", height: "20px", color: "#FFF", opacity: "0.3" }} />
                                    </div>
                                </label> :
                                <button style={{ width: "130px", height: "175px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent', border: "none" }} onClick={() => setCameraModalOpen(true)}>
                                    <AddIcon sx={{ width: "20px", height: "20px", color: "#FFF", opacity: "0.3" }} />
                                </button>
                            }
                        </div>
                    )}

                    {updatedDraftfile?.signedFiles?.length > 0 ? (updatedDraftfile?.signedFiles?.map((fileObj, index) => {
                        return (
                            <div key={index} className='Agreement-Container_Signed-Agreement-Content_Signed-copy-or'>
                                <ClearIcon sx={{ width: "16px", height: "16px", color: "#FFF", opacity: "0.8", position: "absolute", top: 10, right: 10 }} onClick={() => handleFileDelete2(fileObj?.objectId)} />
                                <div onClick={() => handleViewPdfDocument(fileObj.filePath)} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    {renderFileSignedFile(fileObj, fileObj?.id)}
                                </div>
                            </div>
                        )
                    })) : (
                        uploadPdf.length == 0 && <div className='Agreement-Container_Signed-Agreement-Content_Signed-copy'>
                            <div className='Agreement-Container_Signed-Agreement-Content_Signed-copy_Child'>
                                {CheckIsiOSDevice == 'iOS' && <label htmlFor="formId">
                                    <input id="formId" type="file" onChange={handleUploadFile} multiple accept="application/pdf, image/*" capture="environment" />
                                    <DescriptionIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '13px', width: '13px' }} />
                                    <Typography sx={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>Upload Signed PDF</Typography>
                                </label>}
                                {CheckIsiOSDevice !== 'iOS' &&
                                    <button style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent', border: "none" }} onClick={() => setCameraModalOpen(true)}>
                                        <DescriptionIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '13px', width: '13px' }} />
                                        <Typography sx={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>Upload a Photo</Typography>
                                    </button>
                                }
                            </div>
                        </div>
                    )}
                </div>
                <Modal
                    open={cameraModalOpen}
                    onClose={handleClose}
                    aria-labelledby="camera-modal-title"
                    aria-describedby="camera-modal-description"
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", backgroundColor: "rgb(0.0.0.1)" }}
                >
                    <div className='Agreement-Container_camera-modal'>
                        <Camera
                            idealResolution={ratio}
                            imageCompression={1}
                            onTakePhoto={(dataUri) => handleUploadFile(dataUri)}
                            onCameraError={(error) => console.error('Camera error', error)}
                            idealFacingMode={facingMode}
                            isImageMirror={false}
                            isSilentMode={true}
                            isDisplayStartCameraError={false}
                            sizeFactor={1}
                        />
                        <div className='Agreement-Container_camera-modal_registerData_buttonContainer'>
                            <HighlightOffIcon className='Agreement-Container_camera-modal_registerData_buttonContainer_active-button-camera' sx={{ width: "25px", height: "25px", color: "#FFF", left: 2 }} onClick={() => setCameraModalOpen(false)} />
                            <FlipCameraIosIcon className='Agreement-Container_camera-modal_registerData_buttonContainer_active-button-camera' sx={{ width: "25px", height: "25px", color: "#FFF", right: 2 }} onClick={switchCamera} />
                        </div>
                    </div>
                </Modal>
                {AgreementDraftData?.workflowStatus == 'REJECTED' && AgreementDraftData?.workflowComment !== '' && <div className='Agreement-Container_Rejected-Reason'>
                    <div className='Agreement-Container_Rejected-Reason_Chip-rejected-reason'>
                        <Typography sx={{ color: "#F95F5F", fontSize: "10px", fontWeight: 600, fontFamily: "'Noto Sans', sans-serif" }} >{AgreementDraftData?.workflowComment}</Typography>
                    </div>
                </div>}

                {disableUploadButton && <div className='Agreement-Container_Submit-btn'>
                    <button type='submit' disabled={disableSubmitBtn} className='Agreement-Container_Submit-btn_active-button' onClick={handleUploadFilesConvertToPdf}><p style={{ margin: "5px" }}>Upload</p></button>
                </div>}

                {disableSubmitButton && <div className='Agreement-Container_Submit-btn'>
                    <button type='submit' disabled={disableSubmitBtn} className='Agreement-Container_Submit-btn_active-button' onClick={handleClickButton}><p style={{ margin: "5px" }}>Submit</p></button>
                </div>}
                <Modal
                    open={isAgreementUploaded}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    <div className='Agreement-Container_boxContainer'>
                        <Box sx={{ backgroundColor: 'white', borderRadius: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', }}>
                            <img className='Agreement-Container_boxContainer_tickSuccess' src={TickSuccess} alt="" />&nbsp;&nbsp;

                            <div>
                                <Typography className='Agreement-Container_boxContainer_itsDone'>Uploaded</Typography>
                                <Typography fontSize='12px' padding='10px' textAlign='center'>Agreement uploaded successfully</Typography>
                                <div className='Agreement-Container_boxContainer_okbutton-container'>
                                    <button className='Agreement-Container_boxContainer_okbutton-container_button' style={{ whiteSpace: "nowrap" }} onClick={handleDownloadQR}>Go Back</button>
                                </div>
                            </div>

                        </Box>
                    </div>
                </Modal>
            </div>
            {
                isDownloadAgreement && (
                    <div style={{ position: "absolute", top: "0px", zIndex: 40, width: "100%" }}>
                        <DownloadAgreement fileTypeView={fileTypeView} viewPdfType={viewPdfType} viewPdf={viewPdf} setIsDownloadAgreement={setIsDownloadAgreement} />
                    </div>
                )
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        AgreementDraftData: state?.attendanceConfig?.AgreementDraftData,
        UploadfileObjectId: state?.attendanceConfig?.UploadfileObjectId,
        SelectedUploadFiles: state?.attendanceConfig?.SelectedUploadFiles,
        AgreementUploaded: state?.attendanceConfig?.AgreementUploaded,
        SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
        CheckIsiOSDevice: state?.attendanceConfig?.CheckIsiOSDevice,
    }
}
export default Agreement;